import { type Event, createEvent } from 'models';
import { useQuery } from 'query';
import { getNodeEvent } from '../services';
import { getNodeEventDetailQueryKey } from './keys';

export const useNodeEventQuery = (
  { eventId, skipAuth }: { eventId: string; skipAuth?: boolean },
  options?: { throwOnError?: boolean },
) =>
  useQuery<Event>({
    async queryFn() {
      const { data: event } = await getNodeEvent({
        config: skipAuth ? { skipAuth: true } : undefined,
        routeParams: { id: eventId },
      });

      return createEvent(event);
    },
    queryKey: getNodeEventDetailQueryKey({ eventId, skipAuth }),
    throwOnError: true,
    ...options,
  });
